import React from "react"

import Layout from "../components/flayout"
import ContentPage from "../components/contentPage"
import { webLicenses, mobileLicenses } from "../shared/thirdPartyLicenses";

const Page = () => (
  <Layout darkHeader={true} seoFields={seoFields}>
    <ContentPage
      title={'Third Party Licenses'}
      isSmallFonts={true}
    >
        <p>Below is a list of Open Source and/or Third Party Software along with their required license information used by MPROFIT for MPROFIT’s Portfolio Management Solution for Desktop, MPROFIT’s Portfolio Management Cloud Solution and MPROFIT’s Mobile Applications. The listed third party software/files are the intellectual property of the respective suppliers, protected by copyright laws and governed by respective license agreements.</p>

        <h4>Open Source and/or Third Party Software for MPROFIT along with the required license information:</h4>

        <ol type="a">
            <li>Microsoft .Net Framework 2.0
                <p>Title, ownership rights, and intellectual property rights in this software shall remain in Microsoft Corporation, USA. This Software Component is protected by the copyright laws of the United States and international copyright treaties. This software is distributed to you as per the terms and conditions of Microsoft’s .NET Framework Redistributable End User License Agreement.</p>
            </li>
            <li>Microsoft Report Viewer Redistributable 2005 SP1
                <p>The Microsoft Report Viewer 2005 SP1 Redistributable Package includes Windows Forms and ASP.NET Web server controls for viewing reports designed using Microsoft reporting technology <br/>Title, ownership rights, and intellectual property rights in this software shall remain in Microsoft Corporation, USA. This Software Component is protected by the copyright laws of the United States and international copyright treaties. The usage of this software should be as per the terms and conditions of End User License Agreement supplied by Microsoft.</p>
            </li>
            <li>7-Zip
                <p>MPROFIT Software has bundled a part of the 7-Zip program. This software is licensed under the GNU LGPL license. The source code can be found at <UrlLink url="https://www.7-zip.org"/></p>
            </li>
            <li>Bytescout Spreadsheet SDK Software
                <p>The usage of this software should be as per the terms and conditions of Bytescout Software. More information at <UrlLink url="https://cdn.bytescout.com/EULA/License.txt"/></p>
            </li>
            <li>SQLite
                <p>
                    SQLite is a in-process library that implements a self-contained, serverless, zero-configuration, transactional SQL database engine. The code for SQLite is in the public domain and is thus free for use for any purpose, commercial or private. <br/>
                    SQLite Copyright Notice as listed on <UrlLink url="http://www.sqlite.org/copyright.html"/><br/>
                    All of the deliverable code in SQLite has been dedicated to the public domain by the authors. All code authors, and representatives of the companies they work for, have signed affidavits dedicating their contributions to the public domain and originals of those signed affidavits are stored in a firesafe at the main offices of Hwaci. Anyone is free to copy, modify, publish, use, compile, sell, or distribute the original SQLite code, either in source code form or as a compiled binary, for any purpose, commercial or non-commercial, and by any means.<br/>
                    The previous paragraph applies to the deliverable code in SQLite - those parts of the SQLite library that you actually bundle and ship with a larger application. Portions of the documentation and some code used as part of the build process might fall under other licenses. The details here are unclear. We do not worry about the licensing of the documentation and build code so much because none of these things are part of the core deliverable SQLite library.<br/>
                    All of the deliverable code in SQLite has been written from scratch. No code has been taken from other projects or from the open internet. Every line of code can be traced back to its original author, and all of those authors have public domain dedications on file. So the SQLite code base is clean and is uncontaminated with licensed code from other projects.<br/>
                </p>
            </li>
            <li>PDF to Text Converter for .Net from Winnovative Software Solutions
                <p>The usage of this software should be as per the terms and conditions of Winnovative Software Solutions. More information at <UrlLink url="http://www.winnovative-software.com/license-agreement.aspx"/></p>
            </li>
            <li>pdftotext (xPDF tool)
                <p>
                    pdftotext is a standalone executable, which is one of xPDF tools. Xpdf is licensed under the GNU General Public License (GPL), version 2 or 3.<br/>
                    If you are redistributing unmodified copies of Xpdf (or any of the Xpdf tools) in binary form, you need to include all of the documentation: README, main pages (or help files), COPYING, and COPYING3.
                </p>
            </li>
            <li>QPDF
                <p>
                    The usage and redistribution of this software is per the terms and conditions of the license. Visit the link for more info: <UrlLink url="http://qpdf.sourceforge.net/"/> <br/>
                    QPDF is released under the terms of <a href="http://www.opensource.org/licenses/artistic-license-2.0.php">Version 2.0 of the Artistic License.</a>
                </p>
            </li>
        </ol>

        <h4>MIT and Apache 2.0 Open Source Software for MPROFIT along with the required license information:</h4>

        <LicenseTable list={webLicenses}/>

        <p style={{marginBottom: 0}}>
            The above list of Open Source and/or Third Party Software are collectively governed by the following licenses:
        </p>
        <ul>
            <li><strong>The MIT License: <UrlLink url="https://opensource.org/licenses/MIT"/></strong></li>
            <li><strong>The Apache 2.0 License: <UrlLink url="http://www.apache.org/licenses/LICENSE-2.0"/></strong></li>
        </ul>

        <h4>Open Source Software for MPROFIT’s Mobile Applications along with the required license information:</h4>

        <LicenseTable list={mobileLicenses}/>

        <p style={{marginBottom: 0}}>
            The above list of Open Source and/or Third Party Software are collectively governed by the following licenses:
        </p>
        <ul>
            <li><strong>The MIT License: <UrlLink url="https://opensource.org/licenses/MIT"/></strong></li>
            <li><strong>The ISC License: <UrlLink url="https://opensource.org/licenses/ISC"/></strong></li>
            <li><strong>(c)	The BSD-2-Clause License: <UrlLink url="https://opensource.org/licenses/BSD-2-Clause"/></strong></li>
        </ul>

    </ContentPage>
  </Layout>
)

const UrlLink = ({url}) => <a href={url}>{url}</a>

const LicenseTable = ({list}) => {
    return (
        <div style={{overflowX: 'auto'}}>
        <table className={"table"}>
            <thead>
                <tr>
                    <th scope="col">Module Name</th>
                    <th scope="col">License</th>
                    <th scope="col">Repository</th>
                    <th scope="col">License URL</th>
                </tr>
            </thead>
            <tbody>
                {
                    list.map((x,index) => 
                        <tr key={index}>
                            <td>{x.name}</td>
                            <td style={{wordBreak:'break-all'}}>{x.license}</td>
                            <td style={{wordBreak:'break-all'}}><UrlLink url={x.repo}/></td>
                            <td style={{wordBreak:'break-all'}}><UrlLink url={x.url}/></td>
                        </tr>
                    )
                }
            </tbody>
        </table>
        </div>
    )
}

const seoFields = {
    description: "",
    // lang,
    // meta,
    // keywords,
    title: "Third Party Licenses" 
  }

export default Page